const actions = {
  // LOYALTY_POINT ACTIONS
  LIST_LOYALTY_POINTS_LEVELS_BEGIN: 'LIST_LOYALTY_POINTS_LEVELS_BEGIN',
  LIST_LOYALTY_POINTS_LEVELS_SUCCESS: 'LIST_LOYALTY_POINTS_LEVELS_SUCCESS',
  LIST_LOYALTY_POINTS_LEVELS_ERR: 'LIST_LOYALTY_POINTS_LEVELS_ERR',

  GET_LOYALTY_POINTS_LEVEL_DETAILS_BEGIN: 'GET_LOYALTY_POINTS_LEVEL_DETAILS_BEGIN',
  GET_LOYALTY_POINTS_LEVEL_DETAILS_SUCCESS: 'GET_LOYALTY_POINTS_LEVEL_DETAILS_SUCCESS',
  GET_LOYALTY_POINTS_LEVEL_DETAILS_ERR: 'GET_LOYALTY_POINTS_LEVEL_DETAILS_ERR',

  UPDATE_LOYALTY_POINTS_LEVEL_BEGIN: 'UPDATE_LOYALTY_POINTS_LEVEL_BEGIN',
  UPDATE_LOYALTY_POINTS_LEVEL_SUCCESS: 'UPDATE_LOYALTY_POINTS_LEVEL_SUCCESS',
  UPDATE_LOYALTY_POINTS_LEVEL_ERR: 'UPDATE_LOYALTY_POINTS_LEVEL_ERR',

  LIST_LOYALTY_POINTS_TRANSACTIONS_BEGIN: 'LIST_LOYALTY_POINTS_TRANSACTIONS_BEGIN',
  LIST_LOYALTY_POINTS_TRANSACTIONS_SUCCESS: 'LIST_LOYALTY_POINTS_TRANSACTIONS_SUCCESS',
  LIST_LOYALTY_POINTS_TRANSACTIONS_ERR: 'LIST_LOYALTY_POINTS_TRANSACTIONS_ERR',

  listLoyaltyPointsLevelsBegin: () => {
    return {
      type: actions.LIST_LOYALTY_POINTS_LEVELS_BEGIN,
    };
  },

  listLoyaltyPointsLevelsSuccess: (data) => {
    return {
      type: actions.LIST_LOYALTY_POINTS_LEVELS_SUCCESS,
      data,
    };
  },

  listLoyaltyPointsLevelsErr: (err) => {
    return {
      type: actions.LIST_LOYALTY_POINTS_LEVELS_ERR,
      err,
    };
  },

  updateLoyaltyPointsLevelBegin: () => {
    return {
      type: actions.UPDATE_LOYALTY_POINTS_LEVEL_BEGIN,
    };
  },

  updateLoyaltyPointsLevelSuccess: (data) => {
    return {
      type: actions.UPDATE_LOYALTY_POINTS_LEVEL_SUCCESS,
      data,
    };
  },

  updateLoyaltyPointsLevelErr: (err) => {
    return {
      type: actions.UPDATE_LOYALTY_POINTS_LEVEL_ERR,
      err,
    };
  },

  listLoyaltyPointsTransactionsBegin: () => {
    return {
      type: actions.LIST_LOYALTY_POINTS_TRANSACTIONS_BEGIN,
    };
  },

  listLoyaltyPointsTransactionsSuccess: (data) => {
    return {
      type: actions.LIST_LOYALTY_POINTS_TRANSACTIONS_SUCCESS,
      data,
    };
  },

  listLoyaltyPointsTransactionsErr: (err) => {
    return {
      type: actions.LIST_LOYALTY_POINTS_TRANSACTIONS_ERR,
      err,
    };
  },
  getLoyaltyPointsLevelDetailsBegin: () => {
    return {
      type: actions.GET_LOYALTY_POINTS_LEVEL_DETAILS_BEGIN,
    };
  },

  getLoyaltyPointsLevelDetailsSuccess: (data) => {
    return {
      type: actions.GET_LOYALTY_POINTS_LEVEL_DETAILS_SUCCESS,
      data,
    };
  },

  getLoyaltyPointsLevelDetailsErr: (err) => {
    return {
      type: actions.GET_LOYALTY_POINTS_LEVEL_DETAILS_ERR,
      err,
    };
  },
};

export default actions;
